import React, { FunctionComponent, SetStateAction, useContext } from 'react';
import { ThirdPartySystemsConfigFb } from '../services/thirdPartySystemsService';
import { FbTranslationDto } from '../../components/pageLayout/localization/types';

export type TSetAdditionalErrorMessage = (
  fieldName: string,
  message: string | null
) => void;

interface ConfigContextInterface {
  form?: Object;
  thirdPartySystems?: ThirdPartySystemsConfigFb;
  translationConfig?: FbTranslationDto;
  setSelectedLanguage: (value: SetStateAction<string>) => void;
  selectedLanguage: string;
}

const ConfigContext = React.createContext<ConfigContextInterface | null>({
  form: {},
  setSelectedLanguage: () => {},
  selectedLanguage: 'DE',
});

interface ConfigContextProviderProps {
  form?: Object;
  thirdPartySystems?: ThirdPartySystemsConfigFb;
  translationConfig?: FbTranslationDto;
  setSelectedLanguage: (value: SetStateAction<string>) => void;
  selectedLanguage: string;
}

export const ConfigContextProvider: FunctionComponent<
  ConfigContextProviderProps
> = ({
  form,
  thirdPartySystems,
  translationConfig,
  children,
  setSelectedLanguage,
  selectedLanguage,
}) => {
  return (
    <ConfigContext.Provider
      value={{
        form: form,
        thirdPartySystems: thirdPartySystems,
        translationConfig: translationConfig,
        setSelectedLanguage: setSelectedLanguage,
        selectedLanguage: selectedLanguage,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfigContext = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error(
      'useConfigContext must be used within a ConfigContextProvider'
    );
  }
  return context;
};

export default ConfigContext;
